import * as React from "react";
const SvgFiRrAnswerAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-answer-alt_svg__a)">
      <path
        fill="#062147"
        d="M20 0H4C1.794 0 0 1.794 0 4v12c0 2.206 1.794 4 4 4h2.923l3.748 3.156c.382.34.862.509 1.338.509.467 0 .931-.163 1.292-.485L17.147 20H20c2.206 0 4-1.794 4-4V4c0-2.206-1.794-4-4-4m2 16c0 1.103-.897 2-2 2h-3.212c-.232 0-.458.081-.637.229l-4.172 3.415-4.047-3.409A1 1 0 0 0 7.288 18H3.999c-1.103 0-2-.897-2-2V4c0-1.103.897-2 2-2h16c1.103 0 2 .897 2 2zM20 6a1 1 0 0 1-1 1h-4a1 1 0 1 1 0-2h4a1 1 0 0 1 1 1m-2 8a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1m2-4a1 1 0 0 1-1 1h-4a1 1 0 1 1 0-2h4a1 1 0 0 1 1 1m-9.915-4.337A2.1 2.1 0 0 0 8 4c-1.02 0-1.858.668-2.085 1.661l-2.101 9.114a1 1 0 0 0 1.949.449l.511-2.217h3.51l.532 2.225a1 1 0 0 0 1.205.741 1 1 0 0 0 .74-1.205zm-3.35 5.345 1.129-4.899c.01-.046.024-.108.135-.108s.125.062.138.118l1.169 4.89z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-answer-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAnswerAlt;
